export default function Table (pButton)
{
  this.preInitTableDropdownButton = () =>
  {
    const level1Items = pButton.pAttribute.parameters.buttons,
          level3Data =
          {
            BorderWidth :
            [
              { v : ((BEditor.browser.isIE) ? '2px' : '1px'),   t : 'Thin' },
              { v : ((BEditor.browser.isIE) ? '4px' : '3px'), t : 'Medium' },
              { v : ((BEditor.browser.isIE) ? '6px' : '5px'),  t : 'Thick' },
              { v : 'SEP', t : null },
              { v : '1px', t : '1px' },
              { v : '3px', t : '3px' },
              { v : '5px', t : '5px' },
              { v : '7px', t : '7px' },
              { v : 'SEP', t : null },
              { v : 'none', t : 'None' },
              { v : 'SEP', t : null },
              { v : 'More', t : 'More...' }
            ],

            SizeTableWidth :
            [
              { v : '25%', t : '25%' },
              { v : '50%', t : '50%' },
              { v : '75%', t : '75%' },
              { v : '99%', t : '99%' },
              { v : '100%', t : '100%' },
              { v : 'SEP', t : null },
              { v : '100', t : '100px' },
              { v : '200', t : '200px' },
              { v : '300', t : '300px' },
              { v : '400', t : '400px' },
              { v : '500', t : '500px' },
              { v : '600', t : '600px' },
              { v : 'SEP', t : null },
              { v : 'auto', t : 'Auto' },
              { v : 'SEP', t : null },
              { v : 'More', t : 'More...' }
            ],

            SizeTableHeight :
            [
              { v : '50', t : '50px' },
              { v : '75', t : '75px' },
              { v : '100', t : '100px' },
              { v : '150', t : '150px' },
              { v : '200', t : '200px' },
              { v : '250', t : '250px' },
              { v : '300', t : '300px' },
              { v : '400', t : '400px' },
              { v : '500', t : '500px' },
              { v : '600', t : '600px' },
              { v : 'SEP', t : null },
              { v : 'auto', t : 'Auto' },
              { v : 'SEP', t : null },
              { v : 'More', t : 'More...' }
            ],

            SizeWidth :
            [
              { v : '25%', t : '25%' },
              { v : '33%', t : '33%' },
              { v : '50%', t : '50%' },
              { v : '75%', t : '75%' },
              { v : '100%', t : '100%' },
              { v : 'SEP', t : null },
              { v : '50', t : '50px' },
              { v : '75', t : '75px' },
              { v : '100', t : '100px' },
              { v : '150', t : '150px' },
              { v : '200', t : '200px' },
              { v : '250', t : '250px' },
              { v : '300', t : '300px' },
              { v : 'SEP', t : null },
              { v : 'auto', t : 'Auto' },
              { v : 'SEP', t : null },
              { v : 'More', t : 'More...' }
            ],

            SizeHeight :
            [
              { v : '25%', t : '25%' },
              { v : '33%', t : '33%' },
              { v : '50%', t : '50%' },
              { v : '75%', t : '75%' },
              { v : '100%', t : '100%' },
              { v : 'SEP', t : null },
              { v : '10', t : '10px' },
              { v : '15', t : '15px' },
              { v : '20', t : '20px' },
              { v : '25', t : '25px' },
              { v : '50', t : '50px' },
              { v : '100', t : '100px' },
              { v : '150', t : '150px' },
              { v : 'SEP', t : null },
              { v : 'auto', t : 'Auto' },
              { v : 'SEP', t : null },
              { v : 'More', t : 'More...' }
            ],

            TableAlignment :
            [
              { v : 'left', t : 'Left' },
              { v : 'center', t : 'Center' },
              { v : 'right', t : 'Right' },
              { v : 'SEP', t : null },
              { v : 'none', t : 'None' }
            ],

            HorizontalAlign :
            [
              { v : 'left', t : 'Left' },
              { v : 'center', t : 'Center' },
              { v : 'right', t : 'Right' }
            ],

            VerticalAlign :
            [
              { v : 'top', t : 'Top' },
              { v : 'middle', t : 'Middle' },
              { v : 'bottom', t : 'Bottom' }
            ],

            CellsPadding :
            [
              { v : '1', t : '1px' },
              { v : '3', t : '3px' },
              { v : '5', t : '5px' },
              { v : '7', t : '7px' },
              { v : '10', t : '10px' },
              { v : '15', t : '15px' },
              { v : '20', t : '20px' },
              { v : '25', t : '25px' },
              { v : 'SEP', t : null },
              { v : 'none', t : 'None' },
              { v : 'SEP', t : null },
              { v : 'More', t : 'More...' }
            ],

            DialogTableWidth :
            [
              { v : '100%', t : '100%' },
              { v : '75%', t : '75%' },
              { v : '50%', t : '50%' },
              { v : '25%', t : '25%' },
              { v : 'SEP', t : null },
              { v : '600px', t : '600px' },
              { v : '400px', t : '400px' },
              { v : '200px', t : '200px' },
              { v : '100px', t : '100px' },
              { v : 'SEP', t : null },
              { v : 'auto', t : 'auto' }
            ],

            DialogTableHeight :
            [
              { v : '600px', t : '600px' },
              { v : '500px', t : '500px' },
              { v : '400px', t : '400px' },
              { v : '300px', t : '300px' },
              { v : '200px', t : '200px' },
              { v : '100px', t : '100px' },
              { v : 'SEP', t : null },
              { v : 'auto', t : 'auto' }
            ],

            DialogRowHeight :
            [
              { v : '25%', t : '25%' },
              { v : '33%', t : '33%' },
              { v : '50%', t : '50%' },
              { v : '75%', t : '75%' },
              { v : '100%', t : '100%' },
              { v : 'SEP', t : null },
              { v : '10px', t : '10px' },
              { v : '15px', t : '15px' },
              { v : '20px', t : '20px' },
              { v : '25px', t : '25px' },
              { v : '50px', t : '50px' },
              { v : '100px', t : '100px' },
              { v : '150px', t : '150px' },
              { v : 'SEP', t : null },
              { v : 'auto', t : 'auto' }
            ],

            DialogColumnWidth :
            [
              { v : '25%', t : '25%' },
              { v : '33%', t : '33%' },
              { v : '50%', t : '50%' },
              { v : '75%', t : '75%' },
              { v : '100%', t : '100%' },
              { v : 'SEP', t : null },
              { v : '50px', t : '50px' },
              { v : '75px', t : '75px' },
              { v : '100px', t : '100px' },
              { v : '150px', t : '150px' },
              { v : '200px', t : '200px' },
              { v : '250px', t : '250px' },
              { v : '300px', t : '300px' },
              { v : 'SEP', t : null },
              { v : 'auto', t : 'auto' }
            ],

            DialogTableAlignment :
            [
              { v : 'left', t : 'left' },
              { v : 'right', t : 'right' },
              { v : 'SEP', t : null },
              { v : 'none', t : 'none' }
            ],

            DialogBorderWidth :
            [
              { v : 'thin', t : 'thin' },
              { v : 'medium', t : 'medium' },
              { v : 'thick', t : 'thick' },
              { v : 'SEP', t : null },
              { v : '1px', t : '1px' },
              { v : '3px', t : '3px' },
              { v : '5px', t : '5px' },
              { v : '7px', t : '7px' },
              { v : 'SEP', t : null },
              { v : 'none', t : 'none' }
            ]
          };

    let i, j,
        ddKey,
        dropdownInnerHTML,
        ddLevel2HTML = '',
        ddLevel3HTML = '',
        itemParamsHTML,
        item2ParamsHTML,
        level2Items,
        realCommand,
        level2ItemsCounter = 0,
        level3ItemsCounter = 0;

    let ddLevel2Parameters =
        {
          directURL: '/sys/editor/textstylesdropdown?' + BEditor.environment.fullVersion + BEditor.themeResourcesPostfix,
          edgeAlign : 'right',
          offsetX : 2,
          offsetY : -5,
          isTransparent : false,
          dropdownAlign : 'right',
          multiDropdown : {}
        },
        ddLevel3Parameters =
        {
          directURL: '/sys/editor/textstylesdropdown?' + BEditor.environment.fullVersion + BEditor.themeResourcesPostfix,
          edgeAlign : 'right',
          offsetX : 2,
          offsetY : -5,
          isTransparent : false,
          dropdownAlign : 'right',

          multiDropdown :
          {
            ColorDropdown :
            {
              containerId : 'idColorDropdownMainContainer',
              childContainerId : 'idColorDropdownContainer'
            }
          }
        };

    for (ddKey in level3Data)
    {
      ddLevel3HTML += '<div id="id' + ddKey + 'DropdownMainContainer" style="position: absolute; left: -3700px; top: -3700px; z-index: 1; width: 67px; padding: 5px 0;">';
      ddLevel3HTML += '<div id="id' + ddKey + 'DropdownContainer" class="dropdownItems" style="width: 67px;' + (BEditor.browser.isIE ? ' overflow-x: hidden;' : '') + '">';

      for (i = 0; i < level3Data[ddKey].length; i++)
      {
        if (level3Data[ddKey][i].v === 'SEP' && level3Data[ddKey][i].t === null)
        {
          if (ddKey.indexOf('Dialog') !== 0)
          {
            ddLevel3HTML += '<div style="width: 105px; height: 0px; overflow: hidden; margin: 5px 0; border-top: 1px dotted #D0D2D5; font-size: 0;"></div>';
          }
          else
          {
            ddLevel3HTML += '<div class="sep" style="width: 61px; height: 1px; overflow: hidden; margin: 2px; padding: 0; cursor: default; background-color: rgb(204, 204, 204); font-size: 0;"></div>';
          }
        }
        else
        {
          if (ddKey.indexOf('Dialog') !== 0)
          {
            ddLevel3HTML += '<div id="idItemsContainer_L3_' + (level3ItemsCounter++) + '" style="position: relative; width: 56px; overflow: hidden; padding: 5px 0 5px 11px; font-family: Verdana, Arial, Helvetica, sans-serif; font-size: 12px; font-weight: normal; font-style: normal; text-decoration: none;">';
            ddLevel3HTML += level3Data[ddKey][i].t;
            ddLevel3HTML += '<div ddtype="Item" ddvalue="' + level3Data[ddKey][i].v + '" style="position: absolute; top: 0; left: 0; width: 65px; height: 18px; z-index: 7; background: transparent url(' + BEditor.utils.getZGif() + ') 0 0 repeat; cursor: pointer;"></div>';
            ddLevel3HTML += '</div>';
          }
          else
          {
            ddLevel3HTML += '<div ddtype="Item" ddvalue="' + level3Data[ddKey][i].v + '" class="tableDialogInnerDropdownItem" style="width: 62px; height: 17px; overflow: hidden; margin: 0 1px; padding: 3px 0 0 1px;' + (BEditor.browser.isIE ? ' background-image: url(/Admin/html_res/images/z.gif?' + BEditor.environment.version + ');' : '') + ' cursor: pointer; font-family: Verdana, Arial, Helvetica, sans-serif; font-size: 11px;">';
            ddLevel3HTML += level3Data[ddKey][i].t;
            ddLevel3HTML += '</div>';
          }
        }
      }

      ddLevel3HTML += '</div></div>';

      ddLevel3Parameters.multiDropdown[ddKey + 'Dropdown'] = {};
      ddLevel3Parameters.multiDropdown[ddKey + 'Dropdown'].containerId = 'id' + ddKey + 'DropdownMainContainer';
      ddLevel3Parameters.multiDropdown[ddKey + 'Dropdown'].childContainerId = 'id' + ddKey + 'DropdownContainer';
    }

    pButton.pAttribute.MultiDropdownLevel3 = BEditor.dropdowns.createDropdown(pButton.pAttribute.id + '_MultiDropdown_Level3', null, ddLevel3Parameters, ddLevel3HTML, null, null, null, null, null, {'zIndexOffset': 5});
    pButton.initDropdownComponents('idItemsContainer_L3_', level3ItemsCounter - 1, pButton.pAttribute.MultiDropdownLevel3);

    pButton.pAttribute.parameters.dropdownItemsLenght = level1Items.length;

    dropdownInnerHTML = '<div id="idDropdownInnerMainContainer" style="width: 148px; padding: 5px 0; background-color: #F5F5F5;">';

    for (i = 0; i < level1Items.length; i++)
    {
      dropdownInnerHTML += '<div id="idItemsContainer_L1_' + i + '" style="position: relative; width: 137px; overflow: hidden; padding: 5px 0 5px 11px; font-family: Verdana, Arial, Helvetica, sans-serif; font-size: 12px; font-weight: normal; font-style: normal; text-decoration: none;">';
      dropdownInnerHTML += '<span>' + level1Items[i].title + '</span>';

      if (level1Items[i].type && level1Items[i].type === 'DialogButton')
      {
        itemParamsHTML = 'ddtype="Item" ddvalue="' + level1Items[i].command + '"';
      }
      else if (level1Items[i].type && level1Items[i].type === 'CommandButton')
      {
        itemParamsHTML = 'ddtype="Item" ddvalue="' + level1Items[i].command + '"';
      }
      else if (level1Items[i].type && level1Items[i].type === 'MenuButton')
      {
        level2Items = level1Items[i].buttons;
        ddLevel2HTML += '<div id="id' + level1Items[i].name + 'MainContainer" style="position: absolute; left: -3700px; top: -3700px; z-index: 1; width: ' + (level1Items[i].menuWidth + 2) + 'px; padding: 5px 0;">';
        ddLevel2HTML += '<div id="id' + level1Items[i].name + 'Container" style="width: ' + level1Items[i].menuWidth + 'px;">';

        for (j = 0; j < level2Items.length; j++)
        {
          ddLevel2HTML += '<div id="idItemsContainer_L2_' + (level2ItemsCounter++) + '" style="position: relative; width: ' + (level1Items[i].menuWidth - 11) + 'px; overflow: hidden; padding: 5px 0 5px 11px; font-family: Verdana, Arial, Helvetica, sans-serif; font-size: 12px; font-weight: normal; font-style: normal; text-decoration: none;">';
          ddLevel2HTML += level2Items[j].title;

          realCommand = (level2Items[j].command.indexOf('Color') !== -1) ? 'More' : level2Items[j].command;

          if (level2Items[j].type && level2Items[j].type === 'DialogButton')
          {
            item2ParamsHTML = 'ddtype="Item" ddvalue="' + level2Items[j].command + '"';
          }
          else if (level2Items[j].type && level2Items[j].type === 'CommandButton')
          {
            item2ParamsHTML = 'ddtype="Item" ddvalue="' + level2Items[j].command + '"';
          }
          else
          {
            item2ParamsHTML = 'ddtype="ItemMenu" ddvalue="' + level2Items[j].command + '" ddtitle="' + level2Items[j].title + '" ddmenuid="' + pButton.pAttribute.id + '_MultiDropdown_Level3' + '" ddmenupart="' + level2Items[j].type + '"';
            ddLevel2HTML += '<img id="idArrow_' + i + '_' + j + '" src="/Admin/html_res/images/editor-dd-menu-arr1.gif?' + BEditor.environment.version + '" style="position: absolute; top: 7px; right: 9px; width: 3px; height: 5px; z-index: 5;">';
          }

          ddLevel2HTML += '    <div ' + item2ParamsHTML + ' style="position: absolute; top: 0; left: 0; width: ' + (level1Items[i].menuWidth - 2) + 'px; height: 18px; z-index: 7; background: transparent url(' + BEditor.utils.getZGif() + ') 0 0 repeat; cursor: pointer;"></div>';
          ddLevel2HTML += '</div>';

          if (level2Items[j].separator)
          {
            ddLevel2HTML += '<div style="width: ' + level1Items[i].menuWidth + 'px; height: 0px; overflow: hidden; margin: 5px 0; border-top: 1px dotted #D0D2D5; font-size: 0;"></div>';
          }
        }

        ddLevel2HTML += '</div></div>';

        ddLevel2Parameters.multiDropdown[level1Items[i].name] = {};
        ddLevel2Parameters.multiDropdown[level1Items[i].name].containerId = 'id' + level1Items[i].name + 'MainContainer';
        ddLevel2Parameters.multiDropdown[level1Items[i].name].childContainerId = 'id' + level1Items[i].name + 'Container';

        itemParamsHTML = 'ddtype="ItemMenu" ddtitle="' + level1Items[i].title + '" ddmenuid="' + pButton.pAttribute.id + '_MultiDropdown_Level2' + '" ddmenupart="' + level1Items[i].name + '"';
        dropdownInnerHTML += '<img id="idArrow_' + i + '" src="/Admin/html_res/images/editor-dd-menu-arr1.gif?' + BEditor.environment.version + '" style="position: absolute; top: 7px; right: 9px; width: 3px; height: 5px; z-index: 5;">';
      }
      else
      {
        itemParamsHTML = 'ddtype="Item" ddvalue="' + level1Items[i].command + '" ddtitle="' + level1Items[i].title + '" ddmenuid="' + pButton.pAttribute.id + '_MultiDropdown_Level3' + '" ddmenupart="' + level1Items[i].type + '"';
        dropdownInnerHTML += '<img id="idArrow_' + i + '" src="/Admin/html_res/images/editor-dd-menu-arr1.gif?' + BEditor.environment.version + '" style="position: absolute; top: 7px; right: 9px; width: 3px; height: 5px; z-index: 5;">';
      }

      dropdownInnerHTML += '  <div ' + itemParamsHTML + ' ' + (level1Items[i].normalTitle ? 'ddnormaltitle="' + level1Items[i].normalTitle + '"' : '') + (level1Items[i].currentTitle ? 'ddcurrenttitle="' + level1Items[i].currentTitle + '"' : '') + ' style="position: absolute; top: 0; left: 0; width: 147px; z-index: 7; background: transparent url(' + BEditor.utils.getZGif() + ') 0 0 repeat; cursor: pointer;"></div>';
      dropdownInnerHTML += '</div>';
      dropdownInnerHTML += (level1Items[i].separator ? '<div style="width: 148px; height: 0px; overflow: hidden; margin: 5px 0; border-top: 1px dotted #D0D2D5; font-size: 0;"></div>' : '');
    }

    dropdownInnerHTML += '</div>';

    pButton.pAttribute.MultiDropdownLevel2 = BEditor.dropdowns.createDropdown(pButton.pAttribute.id + '_MultiDropdown_Level2', null, ddLevel2Parameters, ddLevel2HTML, null, null, null, null, null, {'zIndexOffset': 3});
    pButton.initDropdownComponents('idItemsContainer_L2_', level2ItemsCounter - 1, pButton.pAttribute.MultiDropdownLevel2);
    pButton.pAttribute.Dropdown = BEditor.dropdowns.createDropdown(pButton.pAttribute.id + '_MultiDropdown_Level1', pButton.pThis, pButton.pAttribute.parameters, dropdownInnerHTML);
    pButton.initDropdownComponents('idItemsContainer_L1_');

    this.preInitInsertTableButton(level1Items[0].parameters);
  };


  this.preInitInsertTableButton = (params) =>
  {
    if (pButton.pGroup.pToolbar.tWindow.BonaDialog === undefined || !pButton.pGroup.pToolbar.tWindow.BonaDialog)
    {
      setTimeout(this.preInitInsertTableButton, 100);
      return;
    }

    pButton.pAttribute.Dialog = pButton.pGroup.pToolbar.tWindow.BonaDialog.createInnerWindow(pButton.pAttribute.id + '_Dialog', ((params) ? params : pButton.pAttribute.parameters));
    BEditor.Dialogs['Table'] = { 'id': pButton.pAttribute.id + '_Dialog', 'codeEditor': pButton.pAttribute.codeEditor, 'dialog': pButton.pAttribute.Dialog};
  };
}